import { combineReducers } from 'redux';
import activeTab from './ActiveTab';

export default combineReducers({
  activeTab,
});
